// src/data/waypoints.js
export const waypoints = [
  {
    id: 1,
    name: "Entry Hall Waypoint",
    zone_id: 1, // Shattered Vestibule - Entry Hall
    position: { x: 5, y: 5 },
    level_requirement: 1,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 1,
    },
    travel_cost: 5,
    travel_cooldown: 300,
    is_unlocked: true, // Starting waypoint, unlocked by default
    rewards: [
      { loot_id: 1 }, // Rusty Sword
      { loot_id: 3 }, // Healing Potion
    ],
  },
  {
    id: 2,
    name: "Flooded Catacombs Waypoint",
    zone_id: 2, // Flooded Catacombs - Drowned Passage
    position: { x: 15, y: 10 },
    level_requirement: 6,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 2,
    },
    travel_cost: 10,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 9 }, // Waterlogged Blade
      { loot_id: 10 }, // Siren’s Charm
    ],
  },
  {
    id: 3,
    name: "Cursed Expanse Waypoint",
    zone_id: 3, // Cursed Expanse Wastes - Ashen Plains
    position: { x: 25, y: 15 },
    level_requirement: 4,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 3,
    },
    travel_cost: 8,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 11 }, // Ashen Cloak
      { loot_id: 12 }, // Veil Shard
    ],
  },
  {
    id: 4,
    name: "King’s Chamber Waypoint",
    zone_id: 19, // Shattered Vestibule - King’s Chamber
    position: { x: 10, y: 20 },
    level_requirement: 21,
    unlock_conditions: {
      type: "zoneCleared",
      zone_id: 19,
      floors: 5, // Must clear 5 floors in this zone
    },
    travel_cost: 20,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 1 }, // Rusty Sword (placeholder, update as needed)
      { loot_id: 3 }, // Healing Potion
    ],
  },
  {
    id: 5,
    name: "Silent Archives Waypoint",
    zone_id: 8, // Sunken Library - Silent Archives
    position: { x: 20, y: 25 },
    level_requirement: 10,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 8,
    },
    travel_cost: 12,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 9 }, // Waterlogged Blade (placeholder, update as needed)
      { loot_id: 10 }, // Siren’s Charm
    ],
  },
  {
    id: 6,
    name: "Smoldering Anvils Waypoint",
    zone_id: 10, // Obsidian Forges - Smoldering Anvils
    position: { x: 30, y: 30 },
    level_requirement: 12,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 10,
    },
    travel_cost: 15,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 11 }, // Ashen Cloak (placeholder, update as needed)
      { loot_id: 12 }, // Veil Shard
    ],
  },
  {
    id: 7,
    name: "Veilspires Waypoint",
    zone_id: 14, // Crystal Spires - Veilspires
    position: { x: 35, y: 35 },
    level_requirement: 16,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 14,
    },
    travel_cost: 18,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 1 }, // Rusty Sword (placeholder, update as needed)
      { loot_id: 3 }, // Healing Potion
    ],
  },
  {
    id: 8,
    name: "Soulrift Nexus Waypoint",
    zone_id: 15, // Soulrift Nexus - Soulrift Nexus Core
    position: { x: 40, y: 40 },
    level_requirement: 17,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 15,
    },
    travel_cost: 20,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 9 }, // Waterlogged Blade (placeholder, update as needed)
      { loot_id: 10 }, // Siren’s Charm
    ],
  },
  {
    id: 9,
    name: "Trial Grounds Waypoint",
    zone_id: 18, // Guardian’s Gauntlet - Trial Grounds
    position: { x: 45, y: 45 },
    level_requirement: 20,
    unlock_conditions: {
      type: "zoneCleared",
      zone_id: 18,
      floors: 5,
    },
    travel_cost: 22,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 11 }, // Ashen Cloak (placeholder, update as needed)
      { loot_id: 12 }, // Veil Shard
    ],
  },
  {
    id: 10,
    name: "Sealed Chambers Waypoint",
    zone_id: 24, // Forgotten Vaults - Sealed Chambers
    position: { x: 50, y: 50 },
    level_requirement: 26,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 24,
    },
    travel_cost: 25,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 1 }, // Rusty Sword (placeholder, update as needed)
      { loot_id: 3 }, // Healing Potion
    ],
  },
  {
    id: 11,
    name: "Veil Nexus Core Waypoint",
    zone_id: 28, // Veil Nexus Core - Core Chamber
    position: { x: 55, y: 55 },
    level_requirement: 30,
    unlock_conditions: {
      type: "zoneCleared",
      zone_id: 28,
      floors: 5,
    },
    travel_cost: 30,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 9 }, // Waterlogged Blade (placeholder, update as needed)
      { loot_id: 10 }, // Siren’s Charm
    ],
  },
  {
    id: 12,
    name: "Sacred Spring Waypoint",
    zone_id: 31, // Oasis of the Lost - Sacred Spring
    position: { x: 60, y: 60 },
    level_requirement: 5,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 31,
    },
    travel_cost: 8,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 11 }, // Ashen Cloak (placeholder, update as needed)
      { loot_id: 12 }, // Veil Shard
    ],
  },
  {
    id: 13,
    name: "Fetid Mire Waypoint",
    zone_id: 36, // Dead Marshes - Fetid Mire
    position: { x: 65, y: 65 },
    level_requirement: 8,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 36,
    },
    travel_cost: 10,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 1 }, // Rusty Sword (placeholder, update as needed)
      { loot_id: 3 }, // Healing Potion
    ],
  },
  {
    id: 14,
    name: "Trader’s Market Waypoint",
    zone_id: 39, // Maw Outpost - Trader’s Market
    position: { x: 70, y: 70 },
    level_requirement: 5,
    unlock_conditions: {
      type: "zoneReached",
      zone_id: 39,
    },
    travel_cost: 8,
    travel_cooldown: 300,
    is_unlocked: false,
    rewards: [
      { loot_id: 9 }, // Waterlogged Blade (placeholder, update as needed)
      { loot_id: 10 }, // Siren’s Charm
    ],
  },
];

export const getWaypointsByZone = (zoneId) => {
  return waypoints.filter((waypoint) => waypoint.zone_id === zoneId);
};

export const isWaypointUnlocked = (waypointId, player) => {
  const waypoint = waypoints.find((wp) => wp.id === waypointId);
  if (!waypoint) return false;

  // Check if the waypoint is already unlocked in player data
  if (player.unlockedWaypoints?.includes(waypointId)) return true;

  // Check level requirement
  if (player.level < waypoint.level_requirement) return false;

  // Check unlock conditions
  if (!waypoint.unlock_conditions) return waypoint.is_unlocked;

  const { type, zone_id, floors } = waypoint.unlock_conditions;
  if (type === "zoneReached") {
    return player.visitedZones?.includes(zone_id) || false;
  } else if (type === "zoneCleared") {
    const floorsCleared = player.floorsClearedByZone?.[zone_id] || 0;
    return floorsCleared >= floors;
  }

  return waypoint.is_unlocked;
};